import { render, staticRenderFns } from "./grid-actions.vue?vue&type=template&id=3b5a6b0a"
import script from "./grid-actions.ts?vue&type=script&lang=js&external"
export * from "./grid-actions.ts?vue&type=script&lang=js&external"
import style0 from "./grid-actions.vue?vue&type=style&index=0&id=3b5a6b0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports